/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planning_Vakanties_Blijft_StaanInputs */

const nl_planning_vakanties_blijft_staan = /** @type {(inputs: Planning_Vakanties_Blijft_StaanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat al is voorbereid of wat je zelf inplant, blijft gewoon staan.`)
};

/**

* @param {Planning_Vakanties_Blijft_StaanInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const planning_vakanties_blijft_staan = /** @type {((inputs?: Planning_Vakanties_Blijft_StaanInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planning_Vakanties_Blijft_StaanInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_planning_vakanties_blijft_staan(inputs)
});
export { planning_vakanties_blijft_staan as "planning.vakanties.blijft_staan" }